import {Link, useLocation} from 'react-router-dom';

const SEARCH_PATHNAME = '/search';

const CardTagSearchLink = ({id, children}) => {
  const location = useLocation();

  return (
    <Link
      target="_self"
      replace={location.pathname === SEARCH_PATHNAME}
      to={{
        pathname: SEARCH_PATHNAME,
        state: {
          tagClickedEvent: {
            id
          }
        }
      }}>
      {children}
    </Link>
  );
};

export default CardTagSearchLink;
